import {
  createColumn,
  createDropdownColumn,
  createCheckboxColumn
} from "../components/Table/Table";

// Audit columns shared across drive signal and signal group and drive test tables
const driveAuditColumns: State.Column[] = [
  createColumn(
    "Created By",
    (driveSignal: Api.AnyItem) => driveSignal.createdBy,
    "driveSignal.createdBy",
    false
  ),
  createColumn(
    "Created Date",
    (driveSignal: Api.AnyItem) => driveSignal.createdDate,
    "driveSignal.createdDate",
    false
  ),
  createColumn(
    "Modified By",
    (driveSignal: Api.AnyItem) => driveSignal.modifiedBy,
    "driveSignal.modifiedBy",
    false
  ),
  createColumn(
    "Modified Date",
    (driveSignal: Api.AnyItem) => driveSignal.modifiedDate,
    "driveSignal.modifiedDate",
    false
  )
];

export const driveSignalColumns: State.Column[] = [
  createColumn(
    "Code",
    (driveSignal: Api.DriveSignal) => driveSignal.code,
    "driveSignal.code",
    true,
    80
  ),
  createDropdownColumn(
    "SignalGroup",
    (driveSignal: Api.DriveSignal) => driveSignal.signalGroupEnumName,
    "driveSignal.signalGroupEnumName",
    true,
    240
  ),
  createColumn(
    "Sw Name",
    (driveSignal: Api.DriveSignal) => driveSignal.swName,
    "driveSignal.swName",
    true,
    300
  ),
  createColumn(
    "Unit Name",
    (driveSignal: Api.DriveSignal) => driveSignal.unitName,
    "driveSignal.unitName",
    true,
    200
  ),
  createColumn(
    "Name",
    (driveSignalGroup: Api.DriveSignalGroup) => driveSignalGroup.name,
    "driveSignalGroup.name",
    true
  ),
  createColumn(
    "Description",
    (driveSignal: Api.DriveSignal) => driveSignal.description,
    "driveSignal.description",
    true
  ),
  createCheckboxColumn(
    "Localizable",
    (driveSignal: Api.DriveSignal) => driveSignal.localizable,
    "driveSignal.localizable",
    true
  ),
  ...driveAuditColumns
];
export const driveTestColumns: State.Column[] = [
  createColumn("Code", (driveTest: Api.DriveTest) => driveTest.code, "driveTest.code", true, 80),
  createColumn(
    "Sw Name",
    (driveTest: Api.DriveTest) => driveTest.swName,
    "driveTest.swName",
    true,
    300
  ),
  createColumn("Name", (driveTest: Api.DriveTest) => driveTest.name, "driveTest.name", true, 300),
  createColumn(
    "Description",
    (driveTest: Api.DriveTest) => driveTest.description,
    "driveTest.description",
    true,
    300
  ),
  createCheckboxColumn(
    "Localizable",
    (driveTest: Api.DriveTest) => driveTest.localizable,
    "driveTest.localizable",
    true,
    300
  ),
  ...driveAuditColumns
];

export const driveSignalGroupColumns: State.Column[] = [
  createColumn(
    "Enum Value",
    (driveSignalGroup: Api.DriveSignalGroup) => driveSignalGroup.enumValue,
    "driveSignalGroup.enumValue",
    true
  ),
  createColumn(
    "Enum Name",
    (driveSignalGroup: Api.DriveSignalGroup) => driveSignalGroup.enumName,
    "driveSignalGroup.enumName",
    true
  ),
  createColumn(
    "Description",
    (driveSignalGroup: Api.DriveSignalGroup) => driveSignalGroup.description,
    "driveSignalGroup.description",
    true
  ),
  createColumn(
    "English Name",
    (driveSignalGroup: Api.DriveSignalGroup) => driveSignalGroup.name,
    "driveSignalGroup.name",
    true
  ),
  ...driveAuditColumns
];
